import React from 'react';
import { actionIcons, logo } from '../../../../configs/Icons';
import { useInit } from '../../../Contexts/InitProvider';
import { useMenus } from '../MenuProvider';
import UserSection from './Components/HeaderRightCol/UserSection';

function MobileHeaderPage() {
    const { handleMenuCollapse } = useMenus();

    const { initInfo } = useInit();

    return (
        <div className="mobile-header h-14 flex flex-row justify-between gap-3 sm:gap-6 md:gap-10 items-center px-4 print:hidden print:h-0;">
            <div onClick={handleMenuCollapse} role="button" tabIndex={-1} className="w-7 h-7">
                <img src={actionIcons.barsW} alt="" className="w-full h-full" />
            </div>
            <div className="h-7.5 ml-[15%]">
                <img src={initInfo?.adminLogo || logo.mainLogoW} alt="Next" className="h-full" />
            </div>
            <div>
                <UserSection />
            </div>
        </div>
    );
}

export default MobileHeaderPage;
